import {ConsultaColunaBanco} from "./consulta-coluna-banco";

export class ConteudoCabecalhoTabelaRim {
    id: number;
    descricao: string;
    alinhamento: string;
    corFundoCabecalho: string;
    tipoDado: string;
    bold: boolean;
    italic: boolean;

    posicaoLinha: number;
    posicaoColuna: number;
    extensaoLinha: number;
    extensaoColuna: number;
    merged: boolean;

    exibir: boolean;

    consultaColunaBanco: ConsultaColunaBanco;
}